import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import LazyLoad from 'react-lazyload';
import './style.scss';

const ImageBox = (props) => {
  const {
    tag: Tag = 'div', className, image, children, loadAtOnce, ...rest
  } = props;
  return (
    <Tag className={cx('component-image-box', className)} {...rest}>
      {
      !loadAtOnce
        ? (
          <LazyLoad height="100%">
            {!!image && <div className="component-image-box-image" style={{ backgroundImage: `url(${image})` }} />}
          </LazyLoad>
        )
        : !!image && <div className="component-image-box-image" style={{ backgroundImage: `url(${image})` }} />

    }
      {children}
    </Tag>
  );
};

ImageBox.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string,
  loadAtOnce: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default ImageBox;
